import React from "react";
import { format } from "date-fns";
import classnames from "classnames";

import { makeStyles } from "@material-ui/styles";
import InfoIcon from "@material-ui/icons/Info";

import { PageFooter, BackButton } from "jazasoft";

import MuiTable from "../../../components/MuiTable";
import { useDeepMemo, useQuery, useSafeState } from "../../../hooks";

import InfoDrawer from "../../system-activity/details/ActivityDetailsDrawer";
import { isEmpty } from "../../../utils/helpers";

const columns = [
  { dataKey: "id", title: "ID" },
  { dataKey: "entityName", title: "Entity Name", filterOptions: { filter: true } },
  { dataKey: "event", title: "Event" },
  { dataKey: "operation", title: "Operation" },
  { dataKey: "searchText", title: "Entity Value" },
  { dataKey: "createdAt", title: "Time" },
  { dataKey: "createdBy", title: "User" },
  { dataKey: "status", title: "Status" },
  { dataKey: "prevValue", title: "Prev Value", hidden: true },
  { dataKey: "currValue", title: "Curr Value", hidden: true },
  { dataKey: "reqParams", title: "Req Params", hidden: true },
  { dataKey: "reqBody", title: "Req Body", hidden: true },
  { dataKey: "respBody", title: "Resp Body", hidden: true }
];

const getExternalId = invoice => {
  if (isEmpty(invoice?.externalIds)) return "";
  const extIdList = JSON.parse(invoice.externalIds);
  return extIdList[0]?.externalId;
};

const useStyles = makeStyles(theme => ({
  root: {}
}));

const InvoiceHistory = props => {
  const classes = useStyles();

  const [drawerState, setDrawerState] = useSafeState({ open: false, userActivity: null });

  const invoiceId = props?.match?.params?.id;
  const { data: invoice = {} } = useQuery(invoiceId && { url: `invoices/${invoiceId}` });

  const { data: activityList = [] } = useQuery(
    !isEmpty(invoice) && {
      url: "system-activities",
      params: {
        search: `type=='USER';(invoiceId==${Number(invoiceId)},(entityName=='Invoice';entityId==${Number(
          invoiceId
        )}),(entityName=='*invoices*';resBody=='*${invoice.invoiceNo}*'),(entityName=='*invoices*';reqBody=='*${getExternalId(invoice)}*'))`,
        sort: "id,desc"
      }
    }
  );

  const rows = useDeepMemo(() => {
    if (isEmpty(activityList)) return [];
    return activityList.map(h => ({ ...h, createdAt: format(h.createdAt, "dd MMM, yyyy HH:mm a") }));
  }, [activityList]);

  const onInfoClick = (event, action, row, onActionComplete) => {
    setDrawerState({ open: true, userActivity: row });
  };

  return (
    <div className={classnames(classes.root)}>
      <InfoDrawer
        open={drawerState?.open || false}
        userActivity={drawerState?.userActivity}
        onDrawerClose={() => setDrawerState({ open: false, userActivity: null })}
      />

      <div style={{ margin: "1.5rem" }}>
        <MuiTable
          title="Invoice History"
          rows={rows}
          columns={columns}
          searchable
          searchKeys={["searchText", "prevValue", "currValue", "reqParams", "reqBody", "respBody"]}
          inlineActions={[{ name: "info", tooltip: "Info", icon: <InfoIcon />, align: "center" }]}
          onInlineActionClick={onInfoClick}
        />

        <PageFooter>
          <BackButton variant="contained" className={classes.button} />
        </PageFooter>
      </div>
    </div>
  );
};

export default InvoiceHistory;
